export default {
  praemien: {
    // Verkehrs-RS nach Anzahl Fahrzeuge
    "VERK": {
      "ARB": "§21",
      // Flotte A
      "GWVERKA": {
        "RANGE": [{
          "@RMIN": "1",
          "@ALIAS": "1-2",
          "@RMAX": "2",
          "SB150": "111,16",
          "SB300": "94,60",
          "SB500": "78,05",
          "SB1000": "70,25"
        }, {
          "@RMIN": "3",
          "@ALIAS": "3-4",
          "@RMAX": "4",
          "SB150": "217,58",
          "SB300": "184,47",
          "SB500": "152,54",
          "SB1000": "137,29"
        }, {
          "@RMIN": "5",
          "@ALIAS": "5-6",
          "@RMAX": "6",
          "SB150": "365,50",
          "SB300": "297,99",
          "SB500": "234,89",
          "SB1000": "211,40"
        }, {
          "@RMIN": "7",
          "@ALIAS": "7-8",
          "@RMAX": "8",
          "SB150": "481,06",
          "SB300": "392,16",
          "SB500": "310,30",
          "SB1000": "279,27"
        }, {
          "@RMIN": "9",
          "@ALIAS": "9-10",
          "@RMAX": "10",
          "SB150": "597,97",
          "SB300": "487,62",
          "SB500": "385,71",
          "SB1000": "347,14"
        }, {
          "@RMIN": "11",
          "@ALIAS": "11-12",
          "@RMAX": "12",
          "SB150": "526,00",
          "SB300": "447,00",
          "SB500": "368,00"
        }, {
          "@RMIN": "13",
          "@ALIAS": "13-14",
          "@RMAX": "14",
          "SB150": "612,00",
          "SB300": "520,00",
          "SB500": "428,00"
        }
        ],
        "plus2": {
          "SB150": "80,00",
          "SB300": "68,00",
          "SB500": "56,00"
        }
      },
      // Flotte B
      "GWVERKB": {
        "RANGE": [{
          "@RMIN": "1",
          "@ALIAS": "1,2",
          "@RMAX": "2",
          "SB150": "201,03",
          "SB300": "171,46",
          "SB500": "140,72",
          "SB1000": "126,65"
        }, {
          "@RMIN": "3",
          "@ALIAS": "4,3",
          "@RMAX": "4",
          "SB150": "454,19",
          "SB300": "385,66",
          "SB500": "318,47",
          "SB1000": "286,62"
        }, {
          "@RMIN": "5",
          "@ALIAS": "5,6",
          "@RMAX": "6",
          "SB150": "687,57",
          "SB300": "584,16",
          "SB500": "480,74",
          "SB1000": "432,67"
        }, {
          "@RMIN": "7",
          "@ALIAS": "7,8",
          "@RMAX": "8",
          "SB150": "908,75",
          "SB300": "772,01",
          "SB500": "636,70",
          "SB1000": "573,03"
        }, {
          "@RMIN": "9",
          "@ALIAS": "9,10",
          "@RMAX": "10",
          "SB150": "1143,59",
          "SB300": "972,34",
          "SB500": "801,09",
          "SB1000": "720,98"
        }, {
          "@RMIN": "11",
          "@ALIAS": "11,12",
          "@RMAX": "12",
          "SB150": "930,00",
          "SB300": "791,00",
          "SB500": "651,00"
        }, {
          "@RMIN": "13",
          "@ALIAS": "13,14",
          "@RMAX": "14",
          "SB150": "1075,00",
          "SB300": "914,00",
          "SB500": "753,00"
        }
        ],
        "plus2": {
          "SB150": "150,00",
          "SB300": "128,00",
          "SB500": "105,00"
        }
      },
      // Flotte C
      "GWVERKC": {
        "RANGE": {
          "@multi": "1",
          "SB150": "18,92",
          "SB300": "15,37",
          "SB500": "13,01",
          "SB1000": "11,71"
        }
      }
    },
    // Firmen-RS nach Anzahl Mitarbeiter
    "FIRM": {
      "@TXT": "Firmen-Rechtsschutz",
      "ARB": "§24",
      "RANGE": [{
        "@RMIN": "0",
        "@RMAX": "0",
        "SB150": "89,49",
        "SB300": "76,37",
        "SB500": "63,24",
        "SB1000": "53,75"
      }, {
        "@RMIN": "1",
        "@RMAX": "3",
        "SB150": "130,06",
        "SB300": "110,97",
        "SB500": "90,69",
        "SB1000": "77,09"
      }, {
        "@RMIN": "4",
        "@RMAX": "6",
        "SB150": "246,82",
        "SB300": "209,50",
        "SB500": "173,38",
        "SB1000": "147,37"
      }, {
        "@RMIN": "7",
        "@RMAX": "10",
        "SB150": "364,43",
        "SB300": "309,76",
        "SB500": "255,10",
        "SB1000": "216,84"
      }, {
        "@RMIN": "11",
        "@RMAX": "15",
        "SB150": "497,04",
        "SB300": "422,48",
        "SB500": "347,93",
        "SB1000": "295,74"
      }, {
        "@RMIN": "16",
        "@RMAX": "20",
        "SB150": "646,88",
        "SB300": "550,56",
        "SB500": "452,81",
        "SB1000": "384,89"
      }, {
        "@RMIN": "21",
        "@RMAX": "25",
        "SB150": "805,00",
        "SB300": "684,25",
        "SB500": "563,50",
        "SB1000": "478,98"
      }, {
        "@RMIN": "26",
        "@RMAX": "30",
        "SB150": "930,00",
        "SB300": "790,50",
        "SB500": "651,00",
        "SB1000": "553,36"
      }, {
        "@RMIN": "31",
        "@RMAX": "40",
        "SB150": "1200,00",
        "SB300": "1020,00",
        "SB500": "840,00",
        "SB1000": "714,01"
      }, {
        "@RMIN": "41",
        "@RMAX": "50",
        "SB150": "1450,00",
        "SB300": "1232,50",
        "SB500": "1015,00",
        "SB1000": "862,76"
      }
      ]
    },
    // Immobilie
    "MIET": {
      "@TXT": "Immobilien-Rechtsschutz",
      "ARB": "§29",
      "SELBST": {
        // nach Fläche in Quadratmeter
        "@TXT": "für vom Eigentümer selbst genutzte gewerbliche Objekte",
        "RANGE": [{
          "@RMIN": "0",
          "@RMAX": "250",
          "SB150": "76,59",
          "SB300": "63,16",
          "SB500": "52,41",
          "SB1000": "47,17"
        }, {
          "@RMIN": "251",
          "@RMAX": "500",
          "SB150": "144,27",
          "SB300": "120,62",
          "SB500": "98,15",
          "SB1000": "88,34"
        }
        ],
        "PLUS": {
          "@RMIN": "500",
          "@UNIT": "250",
          "SB150": "65,84",
          "SB300": "55,09",
          "SB500": "45,69",
          "SB1000": "41,12"
        }
      },
      "MIET": {
        // nach Jahresbruttomiete in Euro
        "@TXT": "für Mieter gewerblicher Objekte",
        "SB150": "7,75",
        "SB300": "6,50",
        "SB500": "5,38",
        "SB1000": "4,84",
        "MIN150": "190,38",
        "MIN300": "159,48",
        "MIN500": "129,81",
        "MIN1000": "116,83"
      },
      "VERMIET": {
        // nach Jahresbruttomiete in Euro
        "@TXT": "für Verrmieter gewerblicher Objekte",
        "SB150": "8,26",
        "SB300": "6,87",
        "SB500": "5,62",
        "SB1000": "5,06",
        "MIN150": "205,22",
        "MIN300": "170,60",
        "MIN500": "139,70",
        "MIN1000": "125,73"
      },
      "GARAGE": {
        // nach Anzahl Objekte
        "@UNIT": "1",
        "@TXT": "für Garagen und Abstellplätze",
        "SB150": "37,41",
        "SB300": "30,32",
        "SB500": "24,73",
        "SB1000": "22,26"
      },
      "UNBEBAUT": {
        // nach Fläche in Quadratmeter
        "@TXT": "für unbebaute Grunstücke",
        "RANGE": {
          "@RMIN": "0",
          "@UNIT": "2500",
          "@PKWMIN": "0",
          "@PKWMAX": "3",
          "SB150": "37,41",
          "SB300": "30,32",
          "SB500": "24,73",
          "SB1000": "22,26"
        }
      }
    },
    // KOMPEX
    "SPEZ": {
      // KOMPEX ohne gew. Immobilien-RS
      // nach Anzahl Mitarbeiter
      "PBV": [{
        "@RMIN": "0",
        "@RMAX": "0",
        "SB150P150": "378,51",
        "SB300P150": "285,94",
        "SB300P300": "235,37",
        "SB500P300": "184,80",
        "SB1000P500": "155,23"
      }, {
        "@RMIN": "1",
        "@RMAX": "3",
        "SB150P150": "463,98",
        "SB300P150": "366,30",
        "SB300P300": "311,41",
        "SB500P300": "229,08",
        "SB1000P500": "193,00"
      }, {
        "@RMIN": "4",
        "@RMAX": "6",
        "SB150P150": "622,61",
        "SB300P150": "488,32",
        "SB300P300": "427,92",
        "SB500P300": "307,11",
        "SB1000P500": "259,51"
      }, {
        "@RMIN": "7",
        "@RMAX": "10",
        "SB150P150": "973,04",
        "SB300P150": "751,34",
        "SB300P300": "664,39",
        "SB500P300": "490,50",
        "SB1000P500": "415,70"
      }, {
        "@RMIN": "11",
        "@RMAX": "15",
        "SB150P150": "1305,07",
        "SB300P150": "1046,52",
        "SB300P300": "985,68",
        "SB500P300": "864,00",
        "SB1000P500": "734,40"
      }, {
        "@RMIN": "16",
        "@RMAX": "20",
        "SB150P150": "1547,21",
        "SB300P150": "1247,75",
        "SB300P300": "1157,33",
        "SB500P300": "976,50",
        "SB1000P500": "832,47"
      }, {
        "@RMIN": "21",
        "@RMAX": "25",
        "SB150P150": "1916,19",
        "SB300P150": "1557,68",
        "SB300P300": "1405,75",
        "SB500P300": "1101,88",
        "SB1000P500": "942,11"
      }, {
        "@RMIN": "26",
        "@RMAX": "30",
        "SB150P150": "2052,75",
        "SB300P150": "1762,95",
        "SB300P300": "1577,80",
        "SB500P300": "1207,50",
        "SB1000P500": "1035,43"
      }, {
        "@RMIN": "31",
        "@RMAX": "40",
        "SB150P150": "2415,00",
        "SB300P150": "1955,00",
        "SB300P300": "1753,33",
        "SB500P300": "1350,00",
        "SB1000P500": "1161,00"
      }, {
        "@RMIN": "41",
        "@RMAX": "50",
        "SB150P150": "2875,00",
        "SB300P150": "2300,00",
        "SB300P300": "2091,67",
        "SB500P300": "1675,00",
        "SB1000P500": "1444,69"
      }, {
        "@RMIN": "51",
        "@RMAX": "60",
        "SB150P150": "3348,80",
        "SB300P150": "2750,80",
        "SB300P300": "2483,87",
        "SB500P300": "1950,00",
        "SB1000P500": "1686,75"
      }, {
        "@RMIN": "61",
        "@RMAX": "70",
        "SB150P150": "3927,83",
        "SB300P150": "3094,65",
        "SB300P300": "2796,23",
        "SB500P300": "2199,38",
        "SB1000P500": "1907,96"
      }, {
        "@RMIN": "71",
        "@RMAX": "80",
        "SB150P150": "4510,30",
        "SB300P150": "3413,20",
        "SB300P300": "3158,80",
        "SB500P300": "2650,00",
        "SB1000P500": "2305,50"
      }, {
        "@RMIN": "81",
        "@RMAX": "90",
        "SB150P150": "5095,65",
        "SB300P150": "3882,40",
        "SB300P300": "3599,31",
        "SB500P300": "3033,13",
        "SB1000P500": "2646,41"
      }, {
        "@RMIN": "91",
        "@RMAX": "100",
        "SB150P150": "5501,60",
        "SB300P150": "4305,60",
        "SB300P300": "3997,07",
        "SB500P300": "3380,00",
        "SB1000P500": "2957,50"
      }
      ],
      // gew. Immobilien-RS für KOMPEX
      // nach Anzahl Mitarbeiter
      "MIET": [{
        "@RMIN": "0",
        "@RMAX": "0",
        "SB150P150": "61,05",
        "SB300P150": "49,72",
        "SB300P300": "42,02",
        "SB500P300": "34,32",
        "SB1000P500": "28,83"
      }, {
        "@RMIN": "1",
        "@RMAX": "3",
        "SB150P150": "61,05",
        "SB300P150": "48,84",
        "SB300P300": "43,32",
        "SB500P300": "35,03",
        "SB1000P500": "29,51"
      }, {
        "@RMIN": "4",
        "@RMAX": "6",
        "SB150P150": "85,45",
        "SB300P150": "73,25",
        "SB300P300": "66,63",
        "SB500P300": "53,41",
        "SB1000P500": "45,13"
      }, {
        "@RMIN": "7",
        "@RMAX": "10",
        "SB150P150": "98,54",
        "SB300P150": "86,22",
        "SB300P300": "80,19",
        "SB500P300": "68,13",
        "SB1000P500": "57,74"
      }, {
        "@RMIN": "11",
        "@RMAX": "15",
        "SB150P150": "110,81",
        "SB300P150": "98,50",
        "SB300P300": "92,67",
        "SB500P300": "81,00",
        "SB1000P500": "68,85"
      }, {
        "@RMIN": "16",
        "@RMAX": "20",
        "SB150P150": "149,73",
        "SB300P150": "137,25",
        "SB300P300": "127,67",
        "SB500P300": "108,50",
        "SB1000P500": "92,49"
      }, {
        "@RMIN": "21",
        "@RMAX": "25",
        "SB150P150": "185,44",
        "SB300P150": "173,07",
        "SB300P300": "164,65",
        "SB500P300": "147,81",
        "SB1000P500": "126,37"
      }, {
        "@RMIN": "26",
        "@RMAX": "30",
        "SB150P150": "317,69",
        "SB300P150": "374,32",
        "SB300P300": "332,88",
        "SB500P300": "250,00",
        "SB1000P500": "217,13"
      }, {
        "@RMIN": "31",
        "@RMAX": "40",
        "SB150P150": "172,50",
        "SB300P150": "195,50",
        "SB300P300": "184,50",
        "SB500P300": "162,50",
        "SB1000P500": "139,75"
      }, {
        "@RMIN": "41",
        "@RMAX": "50",
        "SB150P150": "172,50",
        "SB300P150": "195,50",
        "SB300P300": "184,50",
        "SB500P300": "162,50",
        "SB1000P500": "140,15"
      }, {
        "@RMIN": "51",
        "@RMAX": "60",
        "SB150P150": "179,40",
        "SB300P150": "239,20",
        "SB300P300": "224,46",
        "SB500P300": "195,00",
        "SB1000P500": "168,68"
      }, {
        "@RMIN": "61",
        "@RMAX": "70",
        "SB150P150": "178,53",
        "SB300P150": "273,76",
        "SB300P300": "247,19",
        "SB500P300": "194,06",
        "SB1000P500": "168,35"
      }, {
        "@RMIN": "71",
        "@RMAX": "80",
        "SB150P150": "182,85",
        "SB300P150": "316,94",
        "SB300P300": "290,79",
        "SB500P300": "238,50",
        "SB1000P500": "207,50"
      }, {
        "@RMIN": "81",
        "@RMAX": "90",
        "SB150P150": "181,99",
        "SB300P150": "351,84",
        "SB300P300": "313,68",
        "SB500P300": "237,37",
        "SB1000P500": "207,10"
      }, {
        "@RMIN": "91",
        "@RMAX": "100",
        "SB150P150": "358,80",
        "SB300P150": "382,72",
        "SB300P300": "341,81",
        "SB500P300": "260,00",
        "SB1000P500": "227,50"
      }
      ],
      // KOMPEXplus Firmen-Vertrags-Rechtsschutz für KOMPEX
      // nach Anzahl Mitarbeiter
      "T": [{
        "@RMIN": "0",
        "@RMAX": "0",
        "SB150P150": "77,12",
        "SB300P150": "54,44",
        "SB300P300": "46,14",
        "SB500P300": "37,84",
        "SB1000P500": "31,79"
      }, {
        "@RMIN": "1",
        "@RMAX": "3",
        "SB150P150": "88,46",
        "SB300P150": "65,78",
        "SB300P300": "59,56",
        "SB500P300": "50,23",
        "SB1000P500": "42,32"
      }, {
        "@RMIN": "4",
        "@RMAX": "6",
        "SB150P150": "111,67",
        "SB300P150": "77,49",
        "SB300P300": "72,39",
        "SB500P300": "62,19",
        "SB1000P500": "52,55"
      }, {
        "@RMIN": "7",
        "@RMAX": "10",
        "SB150P150": "123,65",
        "SB300P150": "89,30",
        "SB300P300": "84,53",
        "SB500P300": "74,98",
        "SB1000P500": "63,55"
      }, {
        "@RMIN": "11",
        "@RMAX": "15",
        "SB150P150": "170,24",
        "SB300P150": "124,23",
        "SB300P300": "119,91",
        "SB500P300": "111,26",
        "SB1000P500": "94,57"
      }, {
        "@RMIN": "16",
        "@RMAX": "20",
        "SB150P150": "231,13",
        "SB300P150": "159,48",
        "SB300P300": "155,50",
        "SB500P300": "147,54",
        "SB1000P500": "125,78"
      }, {
        "@RMIN": "21",
        "@RMAX": "25",
        "SB150P150": "286,60",
        "SB300P150": "208,01",
        "SB300P300": "199,95",
        "SB500P300": "183,83",
        "SB1000P500": "157,17"
      }, {
        "@RMIN": "26",
        "@RMAX": "30",
        "SB150P150": "306,59",
        "SB300P150": "250,77",
        "SB300P300": "243,61",
        "SB500P300": "229,28",
        "SB1000P500": "196,61"
      }, {
        "@RMIN": "31",
        "@RMAX": "40",
        "SB150P150": "332,82",
        "SB300P150": "291,22",
        "SB300P300": "278,46",
        "SB500P300": "252,94",
        "SB1000P500": "217,53"
      }, {
        "@RMIN": "41",
        "@RMAX": "50",
        "SB150P150": "356,04",
        "SB300P150": "311,54",
        "SB300P300": "297,89",
        "SB500P300": "270,59",
        "SB1000P500": "233,38"
      }, {
        "@RMIN": "51",
        "@RMAX": "60",
        "SB150P150": "379,05",
        "SB300P150": "331,66",
        "SB300P300": "317,13",
        "SB500P300": "288,07",
        "SB1000P500": "249,18"
      }, {
        "@RMIN": "61",
        "@RMAX": "70",
        "SB150P150": "396,68",
        "SB300P150": "347,09",
        "SB300P300": "331,88",
        "SB500P300": "301,47",
        "SB1000P500": "261,53"
      }, {
        "@RMIN": "71",
        "@RMAX": "80",
        "SB150P150": "415,38",
        "SB300P150": "363,46",
        "SB300P300": "347,54",
        "SB500P300": "315,69",
        "SB1000P500": "274,65"
      }, {
        "@RMIN": "81",
        "@RMAX": "90",
        "SB150P150": "425,27",
        "SB300P150": "372,11",
        "SB300P300": "355,81",
        "SB500P300": "323,21",
        "SB1000P500": "282,00"
      }, {
        "@RMIN": "91",
        "@RMAX": "100",
        "SB150P150": "435,16",
        "SB300P150": "380,77",
        "SB300P300": "364,09",
        "SB500P300": "330,72",
        "SB1000P500": "289,38"
      }
      ],
      // Spezial-Straf-RS für KOMPEX
      // nach Anzahl Mitarbeiter
      "SSRG": [{
        "@RMIN": "0",
        "@RMAX": "0",
        "SB150P150": "91,43",
        "SB300P150": "91,43",
        "SB300P300": "87,08",
        "SB500P300": "87,08",
        "SB1000P500": "82,73"
      }, {
        "@RMIN": "1",
        "@RMAX": "3",
        "SB150P150": "91,43",
        "SB300P150": "91,43",
        "SB300P300": "87,08",
        "SB500P300": "87,08",
        "SB1000P500": "82,73"
      }, {
        "@RMIN": "4",
        "@RMAX": "6",
        "SB150P150": "106,67",
        "SB300P150": "106,67",
        "SB300P300": "101,59",
        "SB500P300": "101,59",
        "SB1000P500": "96,51"
      }, {
        "@RMIN": "7",
        "@RMAX": "10",
        "SB150P150": "121,91",
        "SB300P150": "121,91",
        "SB300P300": "116,10",
        "SB500P300": "116,10",
        "SB1000P500": "110,30"
      }, {
        "@RMIN": "11",
        "@RMAX": "15",
        "SB150P150": "182,86",
        "SB300P150": "182,86",
        "SB300P300": "174,15",
        "SB500P300": "174,15",
        "SB1000P500": "165,44"
      }, {
        "@RMIN": "16",
        "@RMAX": "20",
        "SB150P150": "243,81",
        "SB300P150": "243,81",
        "SB300P300": "232,20",
        "SB500P300": "232,20",
        "SB1000P500": "220,59"
      }, {
        "@RMIN": "21",
        "@RMAX": "25",
        "SB150P150": "320,00",
        "SB300P150": "320,00",
        "SB300P300": "304,76",
        "SB500P300": "304,76",
        "SB1000P500": "289,52"
      }, {
        "@RMIN": "26",
        "@RMAX": "30",
        "SB150P150": "342,86",
        "SB300P150": "342,86",
        "SB300P300": "326,53",
        "SB500P300": "326,53",
        "SB1000P500": "310,20"
      }, {
        "@RMIN": "31",
        "@RMAX": "40",
        "SB150P150": "365,72",
        "SB300P150": "365,72",
        "SB300P300": "348,30",
        "SB500P300": "348,30",
        "SB1000P500": "330,89"
      }, {
        "@RMIN": "41",
        "@RMAX": "50",
        "SB150P150": "388,57",
        "SB300P150": "388,57",
        "SB300P300": "370,07",
        "SB500P300": "370,07",
        "SB1000P500": "351,57"
      }, {
        "@RMIN": "51",
        "@RMAX": "60",
        "SB150P150": "411,43",
        "SB300P150": "411,43",
        "SB300P300": "391,84",
        "SB500P300": "391,84",
        "SB1000P500": "372,25"
      }, {
        "@RMIN": "61",
        "@RMAX": "70",
        "SB150P150": "434,29",
        "SB300P150": "434,29",
        "SB300P300": "413,61",
        "SB500P300": "413,61",
        "SB1000P500": "392,93"
      }, {
        "@RMIN": "71",
        "@RMAX": "80",
        "SB150P150": "457,15",
        "SB300P150": "457,15",
        "SB300P300": "435,38",
        "SB500P300": "435,38",
        "SB1000P500": "413,61"
      }, {
        "@RMIN": "81",
        "@RMAX": "90",
        "SB150P150": "518,10",
        "SB300P150": "518,10",
        "SB300P300": "493,43",
        "SB500P300": "493,43",
        "SB1000P500": "468,76"
      }, {
        "@RMIN": "91",
        "@RMAX": "100",
        "SB150P150": "579,05",
        "SB300P150": "579,05",
        "SB300P300": "551,48",
        "SB500P300": "551,48",
        "SB1000P500": "523,91"
      }
      ],
      // + 1 weiterer Geschäftsführer für KOMPEX
      "PRIV": {
        "SB150": "287,65",
        "SB300": "223,41",
        "SB500": "184,31"
      },
      // Privat-Spezial-Straf-RS für KOMPEX-Geschäftsführer
      "PRIVSSR": {
        "SB150": "54,63",
        "SB300": "33,35",
        "SB500": "28,35"
      },
      // Zweit-/Ferienwohnung für KOMPEX-Geschäftsführer
      "PRIVZW": {
        "SB150": "55,05",
        "SB300": "43,22",
        "SB500": "34,58"
      },
      // Cyber-RS für KOMPEX-Geschäftsführer
      "PRIVCYBER": {
        "SB150": "73,75"
      },
      // Vermieter-RS für KOMPEX-Geschäftsführer
      // nach Jahresbruttomiete in Euro
      // ab 16001 Euro Beitrag in Prozent
      // ab 24001 Euro nur fuer PKS
      "PRIVVM": [{
        "@RMIN": "1",
        "@RMAX": "10000",
        "SB300": "154,32",
        "SB500": "131,17"
      }, {
        "@RMIN": "10001",
        "@RMAX": "16000",
        "SB300": "339,88",
        "SB500": "288,90"
      }, {
        "@RMIN": "16001",
        "@RMAX": "24000",
        "SB300": "2,83",
        "SB500": "1,84"
      }, {
        "@RMIN": "24001",
        "@RMAX": "999999",
        "SB300": "2,83",
        "SB500": "1,84"
      }
      ],
      // Leistungserweiterung PRESTIGE für KOMPEX-Geschäftsführer
      "PRIVPRESTIGE": {
        "SB000": "58,00",
        "SB150": "58,00",
        "SB300": "38,00",
        "SB500": "31,35"
      },
      // PKS-Option KOMPEX ohne GF im privaten Bereich
      "PRIVMINUSGF": {
        "SB150": "-80,00",
        "SB300": "-60,00",
        "SB500": "-40,00"
      }
    }
  }
};
